import React, { Fragment } from "react";
import {useQueryClient} from "react-query";
import { useTripLegChecklist } from "../../../services/trips";
import Icons, { ChecklistIcon } from "../../../icons";
import {Icon, IconButton, Tooltip} from "@material-ui/core";
import moment from "moment";
import __ from "lodash";
import { useAuth0 } from "@auth0/auth0-react";
import useColour from "../../../services/settings/useColour";
const AccessControl = require ("../../../AccessControl");

const ChecklistScreen = (props) => {
  const {tripData, classes, eventBus} = props;

  const {aircraftReg, originAirportCode, destinationAirportCode, airlineCode, flightNo, scheduledDepartureTimeUtc, std} = tripData;
  const etd = tripData.etd;

  const { user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage TRIPS"]);

  const queryClient = useQueryClient();
  const extraKeys = [tripData.uuid];
  const checklist = useTripLegChecklist({queryClient, extraKeys});

  const Note = (props) => {
    return (
      <div className={classes.checklistNote}>
        <li>{props.noteText}</li>
      </div>
    )
  }

  const ChecklistItem = (props) => {
    const {sectionCode, item, tripLegUuid} = props;
    const {itemName, allowNotes, serviceNotes, status, statusValue, indicatorStatus, checklistEditable} = item;
    let backgroundColor = useColour({code: `${sectionCode} BACKGROUND`, status: status||indicatorStatus||'REQUIRED'});
    let color = useColour({code: `${sectionCode} TEXT`, status: status||indicatorStatus||'REQUIRED'});
    const outstandingBackgroundColor = useColour({code: `${sectionCode} BACKGROUND`, status: 'OUTSTANDING'});
    const outstandingColor = useColour({code: `${sectionCode} TEXT`, status: 'OUTSTANDING'});
    const tooltip = __.has(item, "tooltip") ? item.tooltip : null;
    const checklistDetails  = item.checklistDetails ? __.last(item.checklistDetails) : null;
    const lastUpdate = checklistDetails ? `Last Updated ${moment.utc(checklistDetails.timestamp).format("DD/MM/YYY HH:mm")} by ${checklistDetails.userName}` : null;
    let dueIn = "";
    if (__.has(item, "dueByTimeUtc")) {
      if (moment.utc().isBefore(moment.utc(moment.utc(props.etd).add(2, 'hours')))) {
        const duration = moment.duration(moment.utc(item.dueByTimeUtc).diff(moment.utc()));
        dueIn = ` (${duration.humanize(true)})`;
      }
      if (moment.utc().isAfter(moment.utc(moment.utc(item.dueByTimeUtc)).subtract(30, 'minutes')) && status === 'REQUIRED') {
        backgroundColor = outstandingBackgroundColor;
        color = outstandingColor;
      }
    }
    return (
      <div className={classes.checklistItem} style={{backgroundColor, color}}>
        {/* {JSON.stringify(item)} */}
        {tooltip
          ?
            <Tooltip title={tooltip}>
              <div style={{display: "inline-block", textAlign: "left", width: "calc(73% - 42px)"}}>{itemName + dueIn}</div>
            </Tooltip>
          :
            <div style={{display: "inline-block", textAlign: "left", width: "calc(73% - 42px)"}}>{itemName + dueIn}</div>
        }
        {checklistDetails
          ?
            <Tooltip title={lastUpdate}>
              <div style={{display: "inline-block", textAlign: "right", width: "27%"}}>{statusValue}</div>
            </Tooltip>
          :
            <div style={{display: "inline-block", textAlign: "right", width: "27%"}}>{statusValue}</div>
        }
        <div style={{display: "inline-block", textAlign: "right", width: 40, color:"#000000"}}>
          {props.canEdit && checklistEditable?
            <IconButton
              style={{padding:2}}
              color="inherit"
              onClick={()=>{
                eventBus.trigger("TripLegChecklistItemDialog.open",{tripLegUuid, item, title: `${itemName} for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUTC).format("D MMM")}`});
//                eventBus.trigger("RouteView.TimeWindow.TripAction.editChecklistItem",{tripLegUuid, item, title: `${itemName} for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUTC).format("D MMM")}`});
              }}
            >
              <Icon color="inherit">edit</Icon>
            </IconButton>
          :null}
        </div>

        {allowNotes && serviceNotes
        ? <Note
            noteText={serviceNotes}
          />
        : null}
      </div>
    );
  }

  const ChecklistSection = (props) => {
    const {canEdit, sectionName, items, tripLegUuid, etd, displaySectionTitle, sectionCode} = props;
    const doneItems = __.filter(items, (item) => {return item.status === "COMPLETED";});
    const notApplicableItems = __.filter(items, (item) => {return item.status === "NA";});
    const activeItems = __.filter(items, (item) => {return item.status !== "COMPLETED" && item.status !== "NA";});
    const sortedItems = __.sortBy(activeItems, ["dueByTimeUtc"]);
    const displayItems = [...sortedItems, ...doneItems, ...notApplicableItems];
    const numberOfItemsToDisplay = displaySectionTitle ? 14 : 17;

    return (
      <>
        {displaySectionTitle
          ?
            <div className={classes.checklistSectionHeader}>
              <div style={{display: "inline-block", textAlign: "left", width: "100%"}}>{sectionName}</div>
            </div>
          :
            <></>
        }
        <div style={{maxHeight: 40 * numberOfItemsToDisplay, overflowY: "scroll"}}>
          {displayItems.map(item => (
            <ChecklistItem
              tripLegUuid={tripLegUuid}
              sectionCode={sectionCode}
              item={item}
              etd={etd}
              canEdit={canEdit}
            />
          ))}
        </div>
      </>
    );
  }

  const checklistSections = checklist && checklist.data && Array.isArray(checklist.data.generalChecklist)
    ? __.filter(checklist.data.generalChecklist, (section)=>{return props.checklistSections.indexOf(section.sectionCode) >= 0})
    : null;
  return (<Fragment>
    <div style={{width: "100%", paddingBottom: 5}}>
      <div style={{display: "inline-block"}}><Icons style={{position: "relative", top: 2}}>{props.icon}</Icons></div>
      <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>{props.heading || "Checklist"}</div>
      <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
        {/* <ActionButton
          variant="outlined"
          startIcon={<Icon>add</Icon>}
          onClick={()=>{
            eventBus.trigger("RouteView.TimeWindow.TripAction.addNote",{tripLegUuid: tripData.uuid, noteType, title: `Flight Note for  ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUTC).format("D MMM")}`});
          }}
        >
          Add
        </ActionButton> */}
      </div>
    </div>
    <div style={{width: "100%"}}>
      {checklistSections
      ? checklistSections.map(section => (
          <ChecklistSection
            tripLegUuid={tripData.uuid}
            sectionName={section.sectionName}
            sectionCode={section.sectionCode}
            displaySectionTitle={checklistSections.length > 1}
            items={section.items}
            canEdit={canEdit}
            etd={etd || scheduledDepartureTimeUtc}
          />
        ))
      : null}
    </div>

  </Fragment>);
}

export default ChecklistScreen;
